<template>
  <div class="table">
    <div class="dilu-table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        :height="height"
        :row-key="tableConfig.isTree ? tableConfig.isTreeText : ''"
        id="dilu-table"
        :header-cell-style="headerStyle"
        @selection-change="handleSelectionChange"
      >
        >
        <template slot="empty">
          <el-empty :description="$t('config.text9')" :image-size="100"></el-empty>
        </template>

        <slot></slot>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination" v-if="tableConfig.isPage">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerStyle: { background: "#F0F3FA", color: "#707070" },
    };
  },
  props: ["list", "tableConfig", "total", "pageSize","height"],
  mounted() {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    this.$watermark.set(user.username, 0, -30);
  },
  methods: {
    handleSelectionChange(e) {
      this.$emit("handleSelectionChange", e);
    },
    //翻页触发
    currentChange(e) {
      this.$emit("currentChange", e);
    },
  },
};
</script>

<style scoped>
.table {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.dilu-table {
  flex: 1;
  overflow: auto;
}
</style>